import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Star8 } from "./GeometricDivider";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/sufism", label: "Sufism" },
  { to: "/services", label: "Services" },
  { to: "/the-book", label: "The Book" },
  { to: "/book", label: "Book Online" },
  { to: "/mecca-majlis", label: "Mecca Majlis" },
  { to: "/followers", label: "Followers" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-ivory/95 backdrop-blur-md border-b border-gold/20 shadow-sm" : "bg-ivory/70 backdrop-blur-sm"
      }`}
    >
      <div className="container-page flex items-center justify-between h-20">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-3 group">
          <span className="grid place-items-center h-11 w-11 rounded-full border border-gold/60 group-hover:border-gold transition-colors">
            <Star8 size={20} />
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-serif text-lg md:text-xl text-emerald">Hazrat Sufi Sarkar</span>
            <span className="text-[10px] uppercase tracking-[0.3em] text-gold">Habibul Mahboob</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors relative pb-1 ${
                  isActive ? "text-emerald font-semibold" : "text-charcoal-muted hover:text-emerald"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link to="/donate" data-testid="header-donate-btn" className="btn-gold hidden sm:inline-flex !py-2 !px-6 text-sm">
            Donate
          </Link>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(v => !v)}
            className="lg:hidden grid place-items-center h-11 w-11 rounded-full border border-gold/40 text-emerald hover:bg-gold/10"
            aria-label="Toggle navigation"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-[max-height] duration-500 bg-ivory border-t border-gold/20 ${
          open ? "max-h-[600px]" : "max-h-0"
        }`}
      >
        <nav className="container-page flex flex-col py-6 gap-4" data-testid="mobile-nav">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-base ${isActive ? "text-emerald font-semibold" : "text-charcoal-muted"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
          <Link to="/donate" data-testid="mobile-donate-btn" className="btn-gold mt-2 self-start">
            Donate
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
